import { https } from "./api";

export default class {
  constructor() {
    this.instance = https("/financial");
  }

  getTaxes = (
    classificationId,
    qualificationId,
    level,
    preRegistrationDate,
    classSubjectId
  ) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${level}/${preRegistrationDate}/${classSubjectId}/taxes`
    });
  };

  searchPayment = (colligateIdS, avista, classificationIdS) => {
    return this.instance({
      method: "GET",
      url: `${colligateIdS}/${avista}/${classificationIdS}`
    });
  };

  getPaymentOptions = (classificationId, qualificationId, type) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${type}/paymentOptions`
    });
  };

  getInstallment = (
    classificationId,
    qualificationId,
    level,
    preRegistrationDate,
    classSubjectId,
    taxDate
  ) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${level}/${preRegistrationDate}/${classSubjectId}/${taxDate}/installment`
    });
  };

  getScholarships = (
    classificationId,
    qualificationId,
    level,
    preRegistrationDate,
    classSubjectId,
    nOfInstallments
  ) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${level}/${preRegistrationDate}/${classSubjectId}/${nOfInstallments}/scholarships`
    });
  };

  getScholarshipsCritical = (
    classificationId,
    qualificationId,
    level,
    preRegistrationDate,
    classSubjectId,
    nOfInstallments
  ) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${level}/${preRegistrationDate}/${classSubjectId}/${nOfInstallments}/scholarshipsCritical`
    });
  };

  getScholarshipsException = (
    classificationId,
    qualificationId,
    level,
    preRegistrationDate,
    classSubjectId,
    nOfInstallments
  ) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${level}/${preRegistrationDate}/${classSubjectId}/${nOfInstallments}/scholarshipsException`
    });
  };

  getScholarshipsByAttendance = (
    classificationId,
    qualificationId,
    nOfInstallments,
    attendanceCode,
    localCode
  ) => {
    return this.instance({
      method: "GET",
      url: `${classificationId}/${qualificationId}/${nOfInstallments}/${attendanceCode}/${localCode}/scholarshipsByAttendance`
    });
  };

  getExtraScholarship = (coligateId, isPerLet) => {
    return this.instance({
      method: "GET",
      url: `${coligateId}/${isPerLet}/scholarshipsBySecretary`
    });
  };

  resendTax = data => {
    return this.instance({
      method: "POST",
      url: "tax/resend",
      data
    });
  };

  getReusableTax = (cpf) => {
    return this.instance({
      method: "GET",
      url: `${cpf}/reusableTax`,
    });
  };

  resendContractDraft = data => {
    return this.instance({
      method: "POST",
      url: "contract/resend",
      data
    });
  };


  changePayment = data => {
    return this.instance({
      method: "POST",
      url: "changePayment",
      data
    });
  };

  changeDueDate = data => {
    return this.instance({
      method: "POST",
      url: "changeDueDate",
      data
    });
  };
}
